import {
  AutoComplete,
  FormCheckBox,
  FormContainer,
  FormInput,
  ISelectType,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { totemDeviceSchema, TTotemDeviceForm } from "./totemDeviceSchema";
import {
  createTotemDevice,
  getTotemDeviceById,
  updateTotemDeviceById,
} from "../../../../services/totemDevice.service";
import SitesAppsService from "../../../../services/sitesApps.service";
import { DevicePasswordInput } from "./DevicePasswordInput/DevicePasswordInput";

const siteAppExtensionService = new SitesAppsService();
const translationPath = "page.register.totemDevice.";
const TotemDevice = () => {
  const { t } = useTranslation();

  const [siteAppOptions, setSiteAppOptions] = useState<ISelectType[]>([]);

  const { sendRequest: save, loading: sLoading } = useFetch(createTotemDevice);
  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTotemDeviceById
  );
  const { sendRequest: get, loading: gLoading } = useFetch(getTotemDeviceById);

  const { sendRequest } = useFetch(
    siteAppExtensionService.siteAppExtensionList
  );

  const saveHandler = (v: TTotemDeviceForm) => {
    return save({
      name: v.name,
      observation: v.observation ? v.observation : undefined,
      enable: v.enable,
      devicePassword: v.devicePassword ? v.devicePassword : undefined,
      integrationQueues: v.integrationQueues,
      token4uBus: v.token4uBus,
      siteAppId: v.siteApp.id,
    });
  };

  const updateHandler = (v: TTotemDeviceForm, id: string) => {
    return update({
      item: {
        ...v,
        id: id,
        name: v.name,
        observation: v.observation ? v.observation : undefined,
        enable: v.enable,
        devicePassword: v.devicePassword ? v.devicePassword : undefined,
        integrationQueues: v.integrationQueues,
        token4uBus: v.token4uBus,
        siteAppId: v.siteApp.id,
      },
      id: id,
    });
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TTotemDeviceForm>> => {
      const { data, success } = await get(id);

      if (success && data) {
        const newData: TTotemDeviceForm = {
          id: data.id,
          integrationQueues: data.integrationQueues,
          observation: data.observation,
          token4uBus: data.token4uBus,
          name: data.name,
          changePassword: false,
          devicePassword: null,
          enable: data.enable,
          siteApp: data.siteApp,
        };
        return {
          data: newData,
          success: true,
        };
      }
      return {
        data: null,
        success: false,
      };
    },
    [get]
  );
  const loadSiteApp = useCallback(async () => {
    const { data, success } = await sendRequest({ ExtensionCode: "39" });

    if (data && success) {
      setSiteAppOptions(
        data.map((item) => ({ id: item.siteApp.id, name: item.siteApp.name }))
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    loadSiteApp();
  }, [loadSiteApp]);
  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TTotemDeviceForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "totem_device")}
      schema={totemDeviceSchema}
      subtitle={t(translationPath + "new_totem_device")}
      subtitleWatchField={"name"}
      fields={(type) => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} textAlign={"end"}>
            <SwitchInput name="enable" label={t(translationPath + "enable")} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              fullWidth
              label={t(translationPath + "name") || "Name"}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <FormInput
              size="small"
              multiline
              name="observation"
              fullWidth
              minRows={4}
              label={
                t(translationPath + "observation") || "Descriobservationption"
              }
            />
          </Grid>

          <Grid item xs={12} sm={type !== "create" ? 4 : 6}>
            <FormInput
              size="small"
              name="token4uBus"
              fullWidth
              label={t(translationPath + "token_4uBus") || "Token 4uBus"}
            />
          </Grid>
          <Grid item xs={12} sm={type !== "create" ? 4 : 6}>
            <FormInput
              size="small"
              name="integrationQueues"
              fullWidth
              label={
                t(translationPath + "integration_queues") ||
                "Integration Queues"
              }
            />
          </Grid>
          <Grid item xs={12} sm={type !== "create" ? 4 : 6}>
            <AutoComplete
              getOptionLabel={(option) => option.name}
              size="small"
              label={t(translationPath + "site_app")}
              name="siteApp"
              clearIcon={false}
              options={siteAppOptions}
            />
          </Grid>
          {type !== "create" ? (
            <>
              <Grid item xs={12} sm={2}>
                <FormCheckBox
                  name="changePassword"
                  label={`${t(translationPath + "change_password")}`}
                />
              </Grid>
              <DevicePasswordInput />
            </>
          ) : (
            <Grid item xs={12} sm={6}>
              <FormInput
                size="small"
                name="devicePassword"
                fullWidth
                label={
                  t(translationPath + "device_password") || "Device Password"
                }
              />
            </Grid>
          )}
        </Grid>
      )}
    />
  );
};

export default TotemDevice;
